module.exports = __webpack_public_path__ + "static/Lora-Bold-eec9b1b134bfc16624d240b70db7ed59.ttf";